

















import { useHoverListener } from '@/common/utils';
import {
    defineComponent,
    reactive,
    ref,
    Ref,
    toRefs,
    PropType,
} from '@vue/composition-api';
export default defineComponent({
    props: {
        hasArrow: Boolean,
        subListBackground: {
            type: Object as PropType<{background: string}>,
        },
        arrowStyle: {
            type: Object as PropType<{backgroundImage: string}>,
        },
    },
    setup(props) {
        const container: Ref<HTMLDivElement | null> = ref(null);
        const state = reactive({
            hovering: false,
        });
        useHoverListener({
            element: container,
            enter: () => { state.hovering = true; },
            leave: () => { state.hovering = false; },
            enterDelay: 100,
            leaveDelay: 100,
        });
        return {
            container,
            ...toRefs(state),
        };
    },
});
